const storePlanDocument = {
    namespaced: true,
    state: {
        ready: false,
        employerId: null,
        documents: [],
        sbc: null,
        planId:null,
    },
    actions: {
        async load({state, commit}, data) {
            let employerId = data.employerId;
            let planId = data.planId;
            if(!employerId || !planId) return;
            if(state.employerId === employerId && state.planId === planId) return;
            commit("updateDocuments", null);


            let files = await romeApi.get(`employer/${employerId}/plandocument/${planId}`);
            if(files)
            {
                commit("updateDocuments", files.filter(f => f.id != 0));
            }
            commit("updatePlanId", planId);
            commit("updateEmployerId", employerId);
        },

    },
    mutations: {
        updateDocuments(state, value){
           state.documents = value;
        },
        updatePlanId(state, value){
          state.planId = value;
        },
        updateEmployerId(state, value)
        {
          state.employerId = value;
        }
    }
};

export default storePlanDocument;




// WEBPACK FOOTER //
// ./src/plans/x-plan-document.js